import axios from '@/plugins/axios';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  list: [],
};

const actions = {
  async fetchList({ commit }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('rent_rates', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      commit('setList', enumerateArray(data.data.items));
      return data;
    } catch (error) {
      return error;
    }
  },

  async addNew({ dispatch }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.post('rent_rates', params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      await dispatch('fetchList');

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async updateItem({ dispatch }, { id, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.put(`rent_rates/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      await dispatch('fetchList');

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },
};

const mutations = {
  setList(state, payload) {
    state.list = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
